import DashboardMember from '@/components/Dashboard/Member'
import DashboardProspect from '@/components/Dashboard/Prospect'
import DashboardProject from '@/components/Dashboard/Project'
import DashboardInvestment from '@/components/Dashboard/Investment'
import DashboardExit from '@/components/Dashboard/Exit'
import DashboardEvent from '@/components/Dashboard/Event'

let DashboardRoutes = [
  {
    name: 'dashboardMember',
    path: 'member',
    meta: {permission: ['Pages.Members.View']},
    component: DashboardMember,
  },
  {
    name: 'dashboardProspect',
    path: 'prospect',
    meta: {permission: ['Pages.Members.View']},
    component: DashboardProspect,
  },
  {
    name: 'dashboardProject',
    path: 'project',
    meta: {permission: ['Pages.Projects']},
    component: DashboardProject,
  },
  {
    name: 'dashboardInvestment',
    path: 'investment',
    meta: {permission: ['Pages.Investments.View']},
    component: DashboardInvestment,
  },
  {
    name: 'dashboardExit',
    path: 'exit',
    meta: {permission: ['Pages.Exits.View']},
    component: DashboardExit,
  },
  {
    name: 'dashboardEvent',
    path: 'event',
    meta: {permission: ['Pages.Events.View']},
    component: DashboardEvent,
  },
]

export default DashboardRoutes



// WEBPACK FOOTER //
// ./src/router/dashboard.js